import { render, staticRenderFns } from "./PreviousReview.vue?vue&type=template&id=0b1e7f96&scoped=true&"
import script from "./PreviousReview.vue?vue&type=script&lang=js&"
export * from "./PreviousReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e7f96",
  null
  
)

export default component.exports